// @flow

import * as apis from './services/apis'
import * as forms from './modules/forms'
import * as recaptcha from './modules/recaptcha'
import * as utils from './lib/utils'

// libdefs for flow on rollup replace values
declare var ENV: string
declare var VERSION: string
declare var API_URL: string

const ENVIRONMENT = {
  env: ENV,
  version: VERSION,
}

const ENDPOINTS = {
  main: API_URL
}

interface InitParams {
  endpoints?: Object,
  recaptchaSiteKey?: string | void
}

interface ApiInterface {
  collect: apis.CollectAPI
}

interface FormsInterface {
  init (): void
}

export default class Convrrt {

  config: InitParams
  apis: ApiInterface
  forms: FormsInterface

  constructor (opts: InitParams = {}) {

    this.config = {
      endpoints: {
        ...ENDPOINTS,
        ...opts.endpoints
      },
      recaptchaSiteKey: opts.recaptchaSiteKey
    }

    this.apis = {
      collect: new apis.CollectAPI({
        baseURL: this.config.endpoints.main
      })
    }

    this.utils = utils
  }

  initForms ({redirectUrl} = {}) {

    if (!this.config.recaptchaSiteKey) {
      throw new Error('missing recaptchaSiteKey')
    }

    return recaptcha.Init().then((grecaptcha) => {
      return forms.Init({
        lib: this,
        grecaptcha,
        redirectUrl,
        recaptchaSiteKey: this.config.recaptchaSiteKey
      })
    })
  }

  static version () {
    return ENVIRONMENT
  }
}
